import React, { useEffect, useState } from 'react'


import { loadCourseDocuments } from '../utils/Network'
import {  isImage } from '../utils';
import { resolveMediaUrl } from '../../utils/Network';
import UrlEmbed from '../components/UrlEmbed';
import SelectGender from '../components/SelectGender';
import SelectIsPublic from '../components/SelectIsPublic';

import Modal from 'react-modal';
import CourseDocumentSingle from '../components/CourseDocumentSingle';

export default function CourseDocumentsContent({ urlParams, courseId }) {

    const [pageloading, setPageLoading] = useState(false);
    const [course_documents, setCourseDocuments] = useState(null);
    const [filter_talent, setFilterTalent] = useState(null);
    const [filter_course, setFilterCourse] = useState(null);
    const [filter_gender, setFilterGender] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [current_document, setCurrentDocument] = useState(null);
    const [isPublic, setIsPublic] = useState(null);
    const [all_data, setAllData] = useState(null);
    
    
    useEffect(() => {
        if (!courseId) return;
        setPageLoading(true)

        const params = new URLSearchParams(window.location.search);
        params.set('size', '5000');
        params.set('course', String(courseId));
        var filter_query = `?${params.toString()}`;

        loadCourseDocuments(filter_query).then(data => {

            if (data.results){
                const fromApi = data.results || [];
                const courseScoped = fromApi.filter((item) => {
                    if (item?.course == null) return true;
                    return String(item.course) === String(courseId);
                });
                setAllData(courseScoped)
                setCourseDocuments(courseScoped)
            }
            setPageLoading(false)
        })


        setFilterTalent(urlParams.get('talent'));
        setFilterCourse(String(courseId));
        setFilterGender(urlParams.get('gender'));


    }, [courseId]);


    const closeModal = () => {
        setModalIsOpen(false)

    }

    

    const openModal = (current_document) => {
        setCurrentDocument(current_document)
        setModalIsOpen(true)
    }


    const onValue = (value, name) => {
        // alert(name)
        switch (name) {
            case "course":
                setFilterCourse(value)
                break;
            case "talent":
                setFilterTalent(value)
                break;

            case "gender":
                setFilterGender(value)
                break;
            case "is_public":
                var is_public =value
                var temp =all_data
                temp=temp.filter(item => item.public===is_public);
                setCourseDocuments(temp)
                console.log(temp)
                setIsPublic(value)
                break;
            default:
                break;
        }
    }
    

    


    return (
        <>
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="Modal"
                overlayClassName="Overlay"
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title"> </h4>
                    </div>
                    <div className="modal-body text-center">

                        {current_document && isImage(current_document.file) &&
                            <img src={resolveMediaUrl(current_document.file) || current_document.file} alt="" className="modal-img" />

                        }
                        
                        {current_document && current_document.url &&
                            <UrlEmbed height="400" url={current_document.url} />
                        }
                    </div>

                </div>
            </Modal>
            <div className="content-wrapper cms-coursedocuments-page cms-ratings-surface">
                <section className="content">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="box box-primary">
                                <div className="box-header with-border">
                                    <h3 className="box-title">
                                        Contest Documents{' '}
                                        <span style={{ fontSize: 11 }}>
                                            ({course_documents && course_documents.length})
                                        </span>
                                    </h3>
                                    <button type="button" className="btn btn-cm margin-r-5 pull-right " title="List view">
                                        <i className="fa fa-list"></i>
                                    </button>
                                    <a href="/cms/coursedocuments" className="btn btn-cm margin-r-5 pull-right" title="Back to contests">
                                        <i className="fa fa-arrow-left"></i>
                                    </a>
                                </div>
                                {!pageloading && (
                                <div className="box-header cms-ratings-filter">
                                    <form action="">
                                        <div className="box-tools pull-right">
                                            <button type="submit" className="btn btn-cm pull-right mt-2p mr-1 "><i className="fa fa-search"></i></button>
                                        </div>
                                        <div className="filter-container">
                                            <div className=" ">
                                                <SelectGender width={"120px"} value={filter_gender} callback={onValue} />
                                                <input type="hidden" name="gender" value={filter_gender} />
                                            </div>
                                            <div className=" ">
                                                <SelectIsPublic width={"150px"} value={isPublic} callback={onValue} />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                )}
                                <div className="box-body no-padding mt-4">
                                    {pageloading ? (
                                        <p className="text-center" style={{ color: '#7a9ab8', padding: '1.5rem' }}>
                                            Loading…
                                        </p>
                                    ) : (
                                        <div className="table-responsive mailbox-messages padding-10 cms-ratings-grid-wrap">
                                            <ul className="mailbox-attachments rating-documents cms-ratings-grid cms-coursedocuments-grid clearfix">
                                                {course_documents && course_documents.map((item, index) => (
                                                    <li
                                                        key={item.id}
                                                        className="cms-ratings-card"
                                                        style={{ animationDelay: `${Math.min(index, 24) * 0.035}s` }}
                                                    >
                                                        <CourseDocumentSingle callback={openModal} coursedocument={item} />
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>



    )
}
